import { RoyaltyConfig } from "../interface/api/RoyaltyConfig";
import { RoyaltyPartner } from "../interface/api/RoyaltyPartner";

export interface RoyaltyPreview {
  cpiIncrease: number; // e.g. 0.4305 = 43.05%
  adjustedBaseRate: number; // e.g. 85.83
  townAdjustment: number; // e.g. 4.60
  adjustedTicketPrice: number; // the floor, e.g. 90.43
}

/**
 * Mirror of the server-side RoyaltyCalculator, used only for the live preview.
 * Globals come from the fetched config, so there is no hardcoded constant to drift.
 */
export const calcPreview = (
  currentCPI: number,
  townRate: number,
  config: RoyaltyConfig
): RoyaltyPreview => {
  const cpiIncrease = (currentCPI - config.backgroundCpi) / config.backgroundCpi;
  const adjustedBaseRate = config.baseRate * (1 + cpiIncrease);
  const townAdjustment = townRate - config.townBaseRate;
  const adjustedTicketPrice = adjustedBaseRate + townAdjustment;
  return { cpiIncrease, adjustedBaseRate, townAdjustment, adjustedTicketPrice };
};

/**
 * Royalty owed for a single ticket. Surplus adds the partner share to the base
 * royalty; deficit subtracts it (signed difference, no floor — may go negative).
 * Miss Lee (applyDeficit = false) is exempt and always gets the base royalty.
 */
export const calcRoyalty = (
  salePrice: number,
  adjustedTicketPrice: number,
  partner: RoyaltyPartner
): number => {
  const difference = salePrice - adjustedTicketPrice;
  if (difference >= 0 || partner.applyDeficit) {
    return partner.baseRoyalty + difference * partner.rate;
  }
  return partner.baseRoyalty;
};
